// src/component/datatable2/models/SelectionModel.ts
//
// Row selection of DataTable2 across pages. "Select all" selects every row
// of the result (not only the loaded page); the exceptions are the ids that
// differ from that default: unselected rows when selectedAll, selected rows
// otherwise.

export interface IdentifiedRow {
    id: string;
}

export class SelectionModel {
    /** Rows of the loaded page that are selected. */
    static selectedRows<T extends IdentifiedRow>(rows: readonly T[], selectedAll: boolean, exceptions: readonly string[]): T[] {
        return selectedAll
            ? rows.filter(row => !exceptions.includes(row.id))
            : rows.filter(row => exceptions.includes(row.id));
    }

    /**
     * Exceptions after the page's checkboxes changed: the other pages keep
     * theirs, this page's are recomputed from the new selection.
     */
    static exceptionsAfterChange<T extends IdentifiedRow>(
        exceptions: readonly string[],
        pageRows: readonly T[],
        selectedOnPage: readonly T[],
        selectedAll: boolean,
    ): string[] {
        const pageIds = pageRows.map(row => row.id);
        const pageExceptions = selectedAll
            ? pageRows.filter(row => !selectedOnPage.includes(row)).map(row => row.id)
            : pageRows.filter(row => selectedOnPage.includes(row)).map(row => row.id);

        return [
            ...exceptions.filter(id => !pageIds.includes(id)),
            ...pageExceptions,
        ];
    }

    /** Number of selected rows in the whole result. */
    static count(selectedAll: boolean, totalRecords: number, exceptionCount: number): number {
        return selectedAll ? totalRecords - exceptionCount : exceptionCount;
    }
}
